import { useState } from "react";

export function WifiSection({ de, editing, form, setForm, selected }) {
  const [reveal, setReveal] = useState(false);

  return (
    <section className="bg-white border border-navy/10 p-6 md:p-8" data-testid="handbook-wifi">
      <div className="label-caps mb-4">{de ? "WLAN" : "Wi-Fi"}</div>
      {editing ? (
        <>
          <input
            data-testid="handbook-wifi-ssid"
            placeholder={de ? "Netzwerkname (SSID)" : "Network name (SSID)"}
            value={form.wifi_ssid}
            onChange={(e) => setForm({ ...form, wifi_ssid: e.target.value })}
            className="w-full bg-white border border-navy/20 focus:border-gold focus:outline-none px-4 py-2.5 text-navy-dark mb-3"
          />
          <input
            data-testid="handbook-wifi-password"
            placeholder={de ? "Passwort" : "Password"}
            value={form.wifi_password}
            onChange={(e) => setForm({ ...form, wifi_password: e.target.value })}
            className="w-full bg-white border border-navy/20 focus:border-gold focus:outline-none px-4 py-2.5 text-navy-dark"
          />
        </>
      ) : (
        <>
          <div className="mb-3">
            <div className="text-[11px] tracking-widest uppercase text-navy-dark/50 mb-1">SSID</div>
            <div className="font-display text-2xl text-navy" data-testid="wifi-ssid-value">{selected.wifi_ssid || "—"}</div>
          </div>
          <div>
            <div className="text-[11px] tracking-widest uppercase text-navy-dark/50 mb-1">
              {de ? "Passwort" : "Password"}
            </div>
            {selected.wifi_password ? (
              <div className="flex items-center gap-3">
                <div
                  className="font-mono text-lg text-navy tracking-wider select-all"
                  data-testid="wifi-password-value"
                >
                  {reveal ? selected.wifi_password : "•".repeat(Math.max(6, selected.wifi_password.length))}
                </div>
                <button
                  data-testid="wifi-reveal-btn"
                  onClick={() => setReveal((v) => !v)}
                  className="label-caps border-b border-gold text-navy hover:text-gold transition-colors"
                >
                  {reveal ? (de ? "Verbergen" : "Hide") : (de ? "Anzeigen" : "Show")}
                </button>
              </div>
            ) : (
              <div className="text-[13px] text-navy-dark/40">—</div>
            )}
          </div>
        </>
      )}
    </section>
  );
}
